import type { ActorRefFrom, SnapshotFrom } from "xstate";
import { X } from "lucide-react";
import { Modal } from "@design-lab/shared/ui/modal";
import { Button } from "@design-lab/shared/ui";
import type { artworkMachine } from "@design-lab/entities/artwork/model/artwork.machine";
import { ArtworkFeedbackFormModalContent } from "./ArtworkFeedbackFormModalContent";
import { FeedbackToolbarBox } from "./FeedbackToolbarBox";
import { FeedbackThumbActions } from "./FeedbackThumbActions";
import { ArtworkFeedbackThankYou } from "./ArtworkFeedbackThankYou";
import type { FeedbackStates } from "./ArtworkFeedback";

type ArtworkFeedbackProps = {
  artworkState: SnapshotFrom<typeof artworkMachine>;
  sendArtwork: ActorRefFrom<typeof artworkMachine>["send"];
  onPositiveClick: () => void;
  onNegativeClick: () => void;
  onClose: () => void;
  feedbackStates: FeedbackStates;
};

export function ArtworkFeedbackDesktop({
  artworkState,
  sendArtwork,
  onPositiveClick,
  onNegativeClick,
  onClose,
  feedbackStates
}: ArtworkFeedbackProps) {
  const { isIdleState, isFeedbackFormState, isThankYouState, isThankYouNegativeState } =
    feedbackStates;

  return (
    <FeedbackToolbarBox>
      {isIdleState && (
        <>
          <FeedbackThumbActions
            onPositiveClick={onPositiveClick}
            onNegativeClick={onNegativeClick}
          />

          <Button
            variant="icon"
            onPress={onClose}
            className="ml-2 flex size-10 items-center justify-center rounded-lg hover:bg-gray-100"
            aria-label="Close feedback"
            data-testid="artwork-feedback-close"
          >
            <X className="size-5" />
          </Button>
        </>
      )}

      {isFeedbackFormState && (
        <Modal isOpen={true} onClose={onClose} className="max-w-120 h-auto w-full">
          <ArtworkFeedbackFormModalContent artworkState={artworkState} sendArtwork={sendArtwork} />
        </Modal>
      )}
      {(isThankYouState || isThankYouNegativeState) && (
        <ArtworkFeedbackThankYou className="min-h-fit p-5" />
      )}
    </FeedbackToolbarBox>
  );
}
